import { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { Env, UiCodeLimitQty, quantityLimitContainer, quantityLimitSectionId } from '../../../Constants/Configuration'
import QuantityLimit from './QuantityLimit'
import { useAppSelector } from '../../../hooks'
import RenderByProfileOptionWrapper from '../../../Components/Generic/RenderByProfileOptionWrapper'

function QuantityLimitGridLayout({ style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props }, ref) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const workspaceQuantityLimitVisible = useAppSelector(
    state => state.present.configuration.workspaceQuantityLimitVisible,
  )
  const isOmnichannelAndPricesVisibile = useAppSelector(
    state => state.present.configuration.isOmnichannelAndPricesVisibile,
  )

  const quantityLimitDomElementRef = useRef(null)
  const isQuantityLimitFetched = articleSelected.fetchedQuantityLimitData
  const quantityLimitData = useAppSelector(state => state.present.articleDetail.articleSelected.quantityLimitData)
  const islimitQtyVisible = useAppSelector(state => state.present.configuration.limitQtyModule)

  const emptyClass = quantityLimitData?.sizes?.length > 0 ? '' : ' emptyBar'

  useEffect(() => {
    if (isOmnichannelAndPricesVisibile && islimitQtyVisible) {
      const quantityLimitRef = quantityLimitDomElementRef.current
      quantityLimitDomElementRef &&
        props.domElementsRefObserver &&
        props.domElementsRefObserver.observe(quantityLimitRef)

      return () => {
        quantityLimitDomElementRef &&
          props.domElementsRefObserver &&
          props.domElementsRefObserver.unobserve(quantityLimitRef)
      }
    }
  }, [isOmnichannelAndPricesVisibile, props.domElementsRefObserver, quantityLimitDomElementRef])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <RenderByProfileOptionWrapper sectionName={UiCodeLimitQty}>
      <div
        id={quantityLimitSectionId}
        grid-data={props.datagrid}
        className={className + (!isQuantityLimitFetched || !workspaceQuantityLimitVisible ? ' d-none' : '')}
        style={{ ...style }}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className='grid-layout-adjust-wrapper'>
          <div className='drag-handle-grid-container'>
            <DragOutlined />
          </div>
          <div className='diwa-container' ref={quantityLimitDomElementRef} id={quantityLimitContainer}>
            <div className={`label-drag${emptyClass}`}>
              {renderTranslation(language, TranslationKeys.buttonQuantityLimitSection)}
            </div>
            <QuantityLimit bodyref={props.gridCointainerRef} />
          </div>
        </div>
      </div>
    </RenderByProfileOptionWrapper>
  )
}

export default forwardRef(QuantityLimitGridLayout)
